import {
    GET_ALL_EXHIBITORS,
    ADD_EXHIBITOR,
    EDIT_EXHIBITOR,
    DELETE_EXHIBITOR,
    GET_EXHIBITOR,
    CLEAR_EXHIBITOR,
    GET_EXHIBITS
} from '../actions/ExhibitorActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'exhibitors',
    storage,
};

const initialState = {
    data: [],
    totalExhibitors: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',

    exhibits: null
}

const ExhibitorReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_EXHIBITOR: {
            let tempArray = Object.assign({}, state.allExhibitors)
            tempArray.rows = [action.payload, ...state.allExhibitors.rows]
            return {
                ...state,
                allExhibitors: tempArray,
            }
        }
        case EDIT_EXHIBITOR: {
            let tempArray = Object.assign({}, state.allExhibitors)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allExhibitors: tempArray,
            }
        }
        case DELETE_EXHIBITOR: {
            let tempArray = Object.assign({}, state.allExhibitors)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allExhibitors: tempArray,
            }
        }
        case GET_ALL_EXHIBITORS: {
            return {
                ...state,
                data: action.payload.exhibitors.exhibitors,
                currentPage: action.payload.exhibitors.currentPage,
                totalExhibitors: action.payload.exhibitors.totalElements,
                totalPages: action.payload.exhibitors.totalPages,
            }
        }
        case GET_EXHIBITOR: {
            return {
                ...state,
                exhibitor: action.payload.exhibitor,
            }
        }
        case CLEAR_EXHIBITOR: {
            return {
                ...state,
                exhibitor: '',
            }
        }

        case GET_EXHIBITS: {
            return {
                ...state,
                exhibits: action.payload.exhibits.exhibits,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, ExhibitorReducer);
